import Vue from 'vue';

Vue.component('slider-overlay-component', {
    props: {
        classOfOverflownElement: {
            type: String,
            default: '',
        },

        classOfElementToScroll: {
            type: String,
            default: '',
        },

        hiddenClass: {
            type: String,
        },

        visibleClass: {
            type: String,
        },
    },

    data() {
        return {
            overflownElement: null,
            isSideOverlayVisible: false,

            elementToScroll: null,
            allCarBlocks: null,

            nextButton: null,
            prevButton: null,

            isScrollNextDisabled: false,
            isScrollPrevDisabled: false,

            carBlock: null,
            sliderWrapper: null,
            scrollContainer: null,
        };
    },

    computed: {
        toggleOverlayVisibilityClass() {
            return this.isSideOverlayVisible
                ? this.visibleClass
                : this.hiddenClass;
        },

        toggleContainerSpacingClass() {
            return this.isSideOverlayVisible
                ? 'compare-block__container--spacing'
                : '';
        },

        toggleContainerCenterClass() {
            return this.isSideOverlayVisible
                ? ''
                : 'model-new-compare-block--center';
        },

        toggleContainerGradientClass() {
            return this.isScrollNextDisabled
                ? ''
                : 'model-new-compare-block__slider-next-overlay__gradient';
        },

        toggleButtonHolderActiveClass() {
            return this.isScrollNextDisabled
                ? 'compare-block__link-buttons-holder--active'
                : '';
        },
    },

    watch: {
        nextButton(newNextButton) {
            if (!newNextButton) return;
            newNextButton.addEventListener('click', this.toggleScrollNext);
        },

        prevButton(newPrevButton) {
            if (!newPrevButton) return;
            newPrevButton.addEventListener('click', this.toggleScrollPrev);
        },
    },

    created() {
        window.addEventListener('resize', this.handleResize);
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
        this.nextButton.removeEventListener('click', this.toggleScrollNext);
        this.prevButton.removeEventListener('click', this.toggleScrollPrev);
        this.elementToScroll.removeEventListener(
            'mousewheel',
            this.handleManualScroll,
        );
        this.elementToScroll.removeEventListener(
            'touchmove',
            this.handleManualScroll,
        );
        this.elementToScroll.removeEventListener(
            'scroll',
            this.handleManualScroll,
        );
    },

    mounted() {
        this.overflownElement = document.querySelector(
            `.${this.classOfOverflownElement}`,
        );
        this.nextButton = document.getElementById('slider-next');
        this.prevButton = document.getElementById('slider-prev');
        this.elementToScroll = document.getElementsByClassName(
            `${this.classOfElementToScroll}`,
        )[0];
        this.elementToScroll.addEventListener(
            'mousewheel',
            this.handleManualScroll,
        );
        this.elementToScroll.addEventListener(
            'touchmove',
            this.handleManualScroll,
        );
        this.elementToScroll.addEventListener(
            'scroll',
            this.handleManualScroll,
        );
        this.allCarBlocks = document.getElementsByClassName(
            'model-new-compare-block__car',
        );

        this.carBlock = document.getElementsByClassName(
            'model-new-compare-block__car',
        )[0];

        this.scrollContainer = document.querySelector(
            '.compare-block__container',
        );

        this.handleResize();
        this.handleDisableScrollNext();
        this.handleDisableScrollPrev();
    },

    methods: {
        handleResize() {
            if (!this.overflownElement) return;
            const isSmallNumberOfCarsForResolution =
                this.allCarBlocks.length <= 3 &&
                this.overflownElement.clientWidth > 1200;

            if (isSmallNumberOfCarsForResolution) {
                this.isSideOverlayVisible = false;
                return;
            }

            if (
                this.overflownElement.scrollWidth >
                this.overflownElement.clientWidth
            ) {
                this.isSideOverlayVisible = true;
                return;
            }

            this.isSideOverlayVisible = false;
        },

        handleManualScroll() {
            this.handleDisableScrollNext();
            this.handleDisableScrollPrev();
        },

        toggleScrollNext() {
            if (!this.elementToScroll) return;
            if (this.isScrollPrevDisabled) this.isScrollPrevDisabled = false;

            this.handleDisableScrollNext();

            this.elementToScroll.scrollBy({
                left: this.carBlock.clientWidth,
                behavior: 'smooth',
            });
        },

        toggleScrollPrev() {
            if (!this.elementToScroll) return;
            if (this.isScrollNextDisabled) this.isScrollNextDisabled = false;

            this.handleDisableScrollPrev();

            this.elementToScroll.scrollBy({
                left: -this.carBlock.clientWidth,
                behavior: 'smooth',
            });
        },

        handleDisableScrollNext() {
            const containerWidth = this.scrollContainer.offsetWidth;
            const scrollWidth = this.scrollContainer.scrollWidth;
            const scrollLeft = this.scrollContainer.scrollLeft;

            if (scrollLeft + containerWidth >= scrollWidth) {
                this.isScrollNextDisabled = true;
                return;
            }
            this.isScrollNextDisabled = false;
        },

        handleDisableScrollPrev() {
            const scrollLeft = this.scrollContainer.scrollLeft;

            if (scrollLeft === 0) {
                this.isScrollPrevDisabled = true;
                return;
            }

            this.isScrollPrevDisabled = false;
        },
    },
});
